import { useEffect } from 'react';
import axios from 'axios';
import authService from "../Services/authService";

const PUBLIC_VAPID_KEY = "BDGkJYSn5SlKlL1YOcd_qCgPursa6aIrpzA_ypQPL4D9weck8pJObMAfx9YjNEh6-u3KQW9KgWFfCj-E6dOnBBQ";


function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  return new Uint8Array(atob(base64).split('').map(c => c.charCodeAt(0)));
}

async function subscribeUserToPush() {
  const register = await navigator.serviceWorker.ready;
  const existingSubscription = await register.pushManager.getSubscription();

  // Check if already saved in localStorage
  const savedEndpoint = localStorage.getItem("push_endpoint");
  if (existingSubscription && existingSubscription.endpoint === savedEndpoint) {
    console.log("Already subscribed and saved.");
    return;
  }

  const newSubscription = existingSubscription || await register.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(PUBLIC_VAPID_KEY),
  });

  const token = authService.getCurrentUsertoken();

  await fetch(authService.getApiUrl() + "save-subscription", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      user_id: authService.getCurrentuser().id,
      endpoint: newSubscription.endpoint,
      publicKey: btoa(String.fromCharCode(...new Uint8Array(newSubscription.getKey("p256dh")))),
      authToken: btoa(String.fromCharCode(...new Uint8Array(newSubscription.getKey("auth")))),
    })
  });

  // ✅ Save endpoint locally to prevent duplicate posting
  localStorage.setItem("push_endpoint", newSubscription.endpoint);
  console.log("Subscription saved to server.");

  return newSubscription;
}

export default subscribeUserToPush;
